import { AuthCredentials } from '@/types';

export const ApiService = {
  async fetchSprintData(credentials: AuthCredentials, storyPointField: string = 'customfield_10022') {
    const response = await fetch(`/api/atlassian/sprints?storyPointField=${storyPointField}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...credentials,
        storyPointField
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch data');
    }
    
    return await response.json();
  }
};